import React, { ForwardRefRenderFunction, useImperativeHandle, useState } from "react";
import Drawer from "@mui/material/Drawer";
import { IconButton } from "@mui/material";
import { RiCloseCircleLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";

import { PDFViewer } from "../PDFViewer";
import { colors } from "@zapalacorp/tokens";

import useStyles, { DrawerHeader, DrawerTitle } from "./styles";

interface Props {
  file: string | File | null;
  filename?: string;
}

export interface DrawerPropsHandler {
  openModal: () => void;
}

/** Matches `paperProps.maxWidth` in styles — caps PDF fit width when the drawer has not measured yet. */
const DRAWER_PAPER_MAX_WIDTH = 560;

const DrawerInventoryPdf: ForwardRefRenderFunction<DrawerPropsHandler, Props> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [slideEntered, setSlideEntered] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: () => setOpenDrawer(true),
  }));

  return (
    <Drawer
      PaperProps={{ className: classes.paperProps }}
      ModalProps={{ className: classes.modalProps }}
      open={openDrawer}
      title={translate("inventory")}
      anchor="right"
      hideBackdrop
      onClose={() => setOpenDrawer(false)}
      SlideProps={{
        onEntered: () => setSlideEntered(true),
        onExited: () => setSlideEntered(false),
      }}
    >
      <div>
        <DrawerHeader>
          <DrawerTitle>{translate("inventory")}</DrawerTitle>
          <IconButton onClick={() => setOpenDrawer(false)}>
            <RiCloseCircleLine size={20} color={colors.brandBlue600} />
          </IconButton>
        </DrawerHeader>
      </div>
      {openDrawer && slideEntered && (
        <PDFViewer {...props} height={750} mt={40} maxContentWidth={DRAWER_PAPER_MAX_WIDTH} />
      )}
    </Drawer>
  );
};

const DrawerPDF = React.forwardRef(DrawerInventoryPdf);

export { DrawerPDF };
